import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const eventPageStyles = (
	theme: Theme,
	participantsCount?: number,
) => ({
	root: {
		display: 'flex',
		backgroundColor: '#000000',
		height: '100%',
		position: 'relative',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	content: {
		height: '100%',
		overflowY: 'auto',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',

		'&::-webkit-scrollbar': {
			width: '4px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		}
	},
	event: {
		width: '100%',
		position: 'relative',
		maxWidth: '1800px',
		margin: {
			xs: 0,
			sm: '0 auto',
		},
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: {
			xs: 'center',
			md: 'flex-start',
		},
		flexDirection: {
			xs: 'column',
			md: 'row-reverse',
		},
	},
	eventAvatarWrapper: {
		position: {
			xs: 'relative',
			md: 'sticky',
		},
		top: {
			xs: 0,
			md: '100px',
			lg: '150px',
		},
		marginBottom: {
			xs: 0,
			md: '80px',
		},
		marginRight: {
			xs: 0,
			md: '54px',
		},
		marginTop: {
			xs: 0,
			sm: '25px',
			md: 0,
		},
		aspectRatio: '4 / 5',
		display: 'flex',
		alignItems: 'flex-end',
		maxWidth: '640px',
		width: {
			xs: '100%',
			sm: '50vh',
			md: 'calc(75vh - 110px)',
			lg: 'calc(75vh - 190px)',
		},

		maskImage: {
			xs: 'linear-gradient(0deg, rgba(217, 217, 217, 0.00) 0%, rgba(172, 172, 172, 0.44) 4.32%, #737373 9.18%)',
			sm: 'none',
		},
	},
	eventAvatar: ({ accentColor }: { accentColor?: string }) => ({
		borderRadius: {
			xs: 0,
			sm: '8px',
		},
		boxShadow: accentColor ? {
			xs: 'none',
			sm: `0px 0px 64px 0px ${accentColor}99`,
		} : undefined,
	}),
	shortEventInfo: {
		position: 'absolute',
		left: 0,
		bottom: 0,
		p: '12px 20px',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
		flexDirection: 'column',
		background: 'linear-gradient(180.07deg, rgba(0, 0, 0, 0) 49.9%, rgba(0, 0, 0, 0.8) 88.38%)',
	},
	eventData: {
		position: 'relative',
		width: {
			xs: '100%',
			md: '50%',
			lg: '60%',
		},
		p: { xs: '24px 20px', sm: '30px', lg: '80px 70px 80px 125px' },
		marginTop: { xs: '-50px', sm: 0 },
	},
	eventBackground: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		boxShadow: '0 0 20px 20px #000000',
	},
	eventNotification: {
		position: 'fixed',
		top: { xs: '60px', md: '70px' },
		left: 0,
		width: '100%',
		backgroundColor: '#FFFFFF',

		'& .MuiTypography-root': {
			fontFamily: 'Integral CF, sans-serif',
			fontSize: '15px',
			fontWeight: 400,
			lineHeight: '19px',
			textAlign: 'center',
		}
	},
	eventName: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: { xs: '28px', sm: '48px' },
		fontWeight: 700,
		lineHeight: { xs: '40px', sm: '50px' },
		width: 'fit-content',
		background: `linear-gradient(85.88deg, #ECECEC 53.36%, rgba(236, 236, 236, 0.17) 134.8%)`,
		WebkitBackgroundClip: 'text',
		WebkitTextFillColor: 'transparent',
		mt: '8px',
		filter: `drop-shadow(0px 4px 4px #00000040)`,
	},
	eventDataGrid: {
		display: 'flex',
		flexFlow: 'column nowrap',
		rowGap: '18px',
	},
	eventDates: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	eventDataTitle: {
		color: '#FFFFFF',
		fontFamily: 'General Sans, sans-serif',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '18px',
	},
	tiersPlaceholder: {
		border: `1px solid ${Colors.white_a10}`,
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		alignItems: 'center',
		p: '16px',
		borderRadius: '8px',
	},
	tiersPlaceholderTitle: {
		color: Colors.white,
		width: '100%',
		fontWeight: 700,
		fontFamily: 'Montserrat',
		fontSize: '15px',
		lineHeight: '18px',
		textAlign: 'center',
	},
	tiersPlaceholderDescription: {
		color: Colors.white_a90,
		width: '100%',
		fontWeight: 500,
		fontFamily: 'Montserrat',
		fontSize: '13px',
		lineHeight: '21px',
		textAlign: 'center',
	},
	contactHostButton: {
		width: '146px',
		borderRadius: '100px',
		border: `1px solid ${Colors.white_a10}`,
		background: Colors['343434'],
		p: '10px 12px',
		color: Colors.white,
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 700,
		textTransform: 'none',
		lineHeight: '16px',
		gap: '6px',

		'&:hover, &:focus': {
			background: Colors['2A2A2A'],
			border: `1px solid ${Colors.white_a10}`,
			outline: 'unset',
		}
	},
	eventDateList: {
		display: 'flex',
		gap: '14px',
		flexWrap: { xs: 'unset', sm: 'wrap' },
		width: '100%',
		boxSizing: { xs: 'content-box', sm: 'border-box' },
		ml: { xs: '-20px', sm: 0 },
		overflowY: { xs: 'auto', sm: 'unset' },
		p: { xs: '2px 20px', sm: 0 },

		'&::-webkit-scrollbar': {
			height: 0,
			width: 0,
		}
	},
	pastEventDateLabel: {
		p: '9px 12px',
		backgroundColor: '#FFFFFF1A',
		borderRadius: '100px',
		fontStyle: 'italic',
		fontFamily: 'Integral CF, sans-serif !important',
		fontSize: { xs: '10px !important', md: '12px !important' },
		fontWeight: '500 !important',
		lineHeight: '14px !important',
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		borderRadius: '13px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	eventDate: {
		minHeight: '116px',
		minWidth: '118px',
		maxHeight: '116px',
		position: 'relative',
		p: '22px 10px 20px 10px',
		backgroundColor: '#0000000D',
		boxShadow: '0 0 0 1px #FFFFFF4D',
		borderRadius: '13px',
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		fontSize: '16px',
		gap: '6px',

		'& >svg': {
			color: '#FFFFFF',
			width: '20px',
			height: '20px',
			mb: '6px',
		},

		'& .MuiTypography-root': {
			color: '#FFFFFF',
			fontFamily: 'General Sans, sans-serif',
			fontSize: '16px',
			fontWeight: 600,
			lineHeight: '18px',
		},

		'&:hover': {
			background: '#FFFFFF0D',
			boxShadow: '0 0 0 1px #E8E8E8',
		}
	},
	eventDatesLoader: {
		minHeight: '116px',
		minWidth: '118px',
		backgroundColor: '#0000000D',
		boxShadow: '0 0 0 1px #FFFFFF4D',
		borderRadius: '13px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		'& .MuiCircularProgress-root': {
			color: '#FFFFFF'
		}
	},
	eventDataGridItem: {
		display: 'flex',
		alignItems: 'center',
		columnGap: '16px',

		'& >svg': {
			width: '24px',
			height: '24px',
			color: '#FFFFFF',
		}
	},
	eventDataGridItemText: {
		flex: 1,
		color: '#FFFFFF',
		fontFamily: 'General Sans, sans-serif',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '18px',
		maxWidth: 'fit-content',
	},
	eventSoldOutPlaceholder: {
		p: '16px',
		borderRadius: '8px',
		border: `1px solid ${Colors.white_a30}`,
		backgroundColor: Colors.white_a5,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: '8px',
	},
	eventSoldOutPlaceholderTextBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	eventSoldOutPlaceholderTitle: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		lineHeight: '18px',
		color: Colors.white,
		wordWrap: 'break-word',
	},
	eventSoldOutPlaceholderDescription: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 700,
		lineHeight: '21px',
		color: Colors.white_a90,
		wordWrap: 'break-word',
	},
	pastEventLabel: {
		flex: 1,
		color: '#FFFFFF',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '12px',
		fontStyle: 'italic',
		fontWeight: 600,
		lineHeight: '14px',
		maxWidth: 'fit-content',
	},
	eventRSVPAvatarGroup: {
		'& .MuiAvatar-root': {
			border: '1.5px solid #F4F4F4',
			width: '32px',
			height: '32px',
		},
		'& .MuiAvatar-root:first-of-type': participantsCount > 3 ? {
			top: '2px',
			border: 'none',
			backgroundColor: '#FFFFFF',
			color: '#000000',
			width: '45px',
			borderRadius: '30px',
			fontFamily: 'Montserrat',
			fontSize: '12px',
			fontWeight: 600,
			lineHeight: '15px',
		} : {},
	},
	eventDescription: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '16px',
	},
	eventDescriptionTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: 600,
		fontSize: '20px',
		lineHeight: '24px',
		color: '#FFFFFF',
	},
	eventDescriptionText: {
		fontFamily: 'Montserrat',
		fontWeight: 500,
		fontSize: '15px',
		lineHeight: '24px',
		whiteSpace: 'break-spaces',
		color: '#FFFFFF',

		'& a': {
			color: '#FFFFFF',
		},

		'& p': {
			margin: 0,
		}
	},
	eventFitnessTypes: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: '16px',
	},
	link: {
		fontFamily: 'General Sans, sans-serif',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '18px',
		color: '#FFFFFFCC',
		cursor: 'pointer',
		width: '50px',

		"&:hover": {
			textDecoration: 'underline',
		}
	},
	communities: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	communitiesTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: 500,
		fontSize: '20px',
		lineHeight: '24px',
		textTransform: 'uppercase',
		color: '#FFFFFF',
	},
	eventMapBox: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '24px',
	},
	eventMapTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: 500,
		fontSize: '20px',
		lineHeight: '24px',
		textTransform: 'uppercase',
		color: '#FFFFFF',
	},
	separator: {
		width: '100%',
		height: '1px',
		backgroundColor: '#FFFFFF33',
	},
	communityEventsTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '20px',
		fontWeight: 500,
		lineHeight: '24px',
		color: '#FFFFFF',

		"& >span": {
			textDecoration: 'underline',
		}
	},
	eventActionsMenu: {
		position: 'absolute',
		left: 0,
		bottom: '60px',
		width: '100%',
		backgroundColor: '#000000',
	},
	eventActionsMenuHeader: {
		p: '11px 16px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '6px'
	},
	eventActionsMenuHeaderText: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		color: '#FFFFFF',
	},
	eventActionsMenuHeaderLink: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '13px',
		fontWeight: 400,
		lineHeight: '16px',
		color: '#FFFFFF',

		'&:hover': {
			textDecoration: 'underline',
		}
	},
	eventActionsMenuContent: {
		borderTop: '2px solid #FFFFFF',
		p: '24px 20px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '16px',
	},
	eventFooter: {
		width: '100%',
		gap: '32px',
		display: 'flex',
		justifyContent: 'space-between',
		position: 'fixed',
		left: 0,
		bottom: 0,
		pt: '57px',
		pb: '18px',
		px: {
			xs: '23px',
			sm: '50px',
			lg: '126px',
		},
		background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 30.43%, #000 84.78%)',
	},
	button: {
		width: '154px',
		height: '100%',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',
		borderRadius: '100px',
		backgroundColor: '#000000',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF4D',
		p: '16px 22px',
		gap: '10px',

		"& >svg": {
			width: '24px',
			height: '24px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},

		'&:disabled': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
			opacity: 0.5,
		},
	},
	secondaryButton: {
		backgroundColor: '#222327',
		border: 0,
		gap: '8px',

		"& >svg": {
			width: '16px',
			height: '16px',
		},

		'&:hover': {
			backgroundColor: 'rgba(250, 250, 250, 0.5)',
			color: '#FFFFFF',

			'& .tooltip': {
				display: 'flex',
			},
		},
	},
	sentryFeedbackButton: {
		position: 'relative',
		top: 0,
		left: 0,
	},
	iconButton: {
		width: 'auto',
		borderRadius: '100px',
		color: '#E4E4E4',

		'& >svg': {
			width: '24px',
			height: '24px',
		}
	},
	footerSeparator: {
		height: '100%',
		width: '1px',
		backgroundColor: 'white',
	},
	joinButton: {
		flex: 1,
		fontSize: '14px',
		lineHeight: '16px',
		fontFamily: 'Montserrat',
		maxWidth: { xs: 'unset', sm: '314px' },
		borderColor: 'white',
		p: '10px 24px',
		fontWeight: '600'
	},
	joinChatActionIcon: {
		position: 'relative',
		top: '3px',
	},
	joinChatButtonTooltip: {
		cursor: 'default',
		position: 'absolute',
		display: 'none',
		top: '115%',
		borderRadius: '10px',
		border: '1px solid #120E0D',
		right: { xs: 'initial', md: '10px' },
		p: '5px 10px',
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: 500,
		fontSize: { xs: '12px', md: '14px', lg: '16px' },
		lineHeight: 1.2,
	},
	membershipBox: {
		borderRadius: '8px',
		border: '1px solid #9B9B9B1A',
		backgroundColor: '#0000004D',
		color: 'white',
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: 'center',
		justifyContent: 'space-between',
		p: '24px 32px',
		gap: '16px',
	},
	membershipTextBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '14px',
	},
	membershipTitle: {
		fontFamily: 'General Sans, sans-serif',
		fontSize: '18px',
		fontWeight: '700',
	},
	membershipDescription: {
		fontFamily: 'Hind',
		fontSize: '15px',
		fontWeight: '500',
	},
	membershipButton: {
		border: '1px solid #FFFFFF',
		borderRadius: '58px',
		textTransform: 'none',
		width: '140px',
		height: '35px',
		color: 'white',
		fontFamily: 'General Sans, sans-serif',
		fontWeight: '600',
		fontSize: '14px',
		py: 0,
	},
});
